import './date.less'
import m from 'mithril'
import {Component, classes} from '@codeurs/front'
import {format} from 'date-fns'

export default class PublishedDate extends Component<{
	date: string
	class?: string
}> {
	view() {
		const {date, class: className} = this.attrs
		return m('.date', classes(className), this.getDate(date))
	}
	getDate(date: string) {
		if (date) return format(date, 'D MMMM YYYY')
		return
	}
}
